module.exports = __webpack_public_path__ + "img/h4.cfde2316.png";